(function () {
  'use strict';

  var IMAGE_EXT = /\.(jpe?g|png|gif|webp|svg|bmp|heic)$/i;

  function parseConfig(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatBytes(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function resourceType(file) {
    return IMAGE_EXT.test(file.name) ? 'image' : 'raw';
  }

  function uploadToCloudinary(file, cloud, preset) {
    var type = resourceType(file);
    var url =
      'https://api.cloudinary.com/v1_1/' +
      encodeURIComponent(cloud) +
      '/' +
      type +
      '/upload';
    var body = new FormData();
    body.append('file', file);
    body.append('upload_preset', preset);
    body.append('folder', 'ch-signs-orders');

    return fetch(url, { method: 'POST', body: body }).then(function (res) {
      if (!res.ok) throw new Error('Upload failed (' + res.status + ')');
      return res.json();
    });
  }

  function buildOrderSummary(form) {
    var lines = [];
    var pick = function (sel) {
      var el = form.querySelector(sel);
      return el && el.value ? el.value.trim() : '';
    };

    lines.push('--- Order details ---');
    lines.push('Service: ' + pick('#OrderService'));
    lines.push('Size: ' + pick('#OrderSize'));
    lines.push('Quantity: ' + pick('#OrderQty'));
    lines.push('Turnaround: ' + pick('#OrderTurnaround'));
    lines.push('Phone: ' + pick('#OrderPhone'));

    var urls = pick('#OrderArtworkUrls');
    if (urls) {
      lines.push('');
      lines.push('Artwork files:');
      urls.split('\n').forEach(function (u) {
        if (u.trim()) lines.push(u.trim());
      });
    }

    var instructions = pick('#OrderInstructions');
    if (instructions) {
      lines.push('');
      lines.push('Special instructions:');
      lines.push(instructions);
    }

    return lines.join('\n');
  }

  function initFileList(input, listEl) {
    if (!input || !listEl) return;

    input.addEventListener('change', function () {
      listEl.innerHTML = '';
      if (!input.files || !input.files.length) {
        listEl.hidden = true;
        return;
      }
      Array.prototype.forEach.call(input.files, function (file) {
        var li = document.createElement('li');
        li.textContent = file.name + ' (' + formatBytes(file.size) + ')';
        listEl.appendChild(li);
      });
      listEl.hidden = false;
    });
  }

  function initOrderForm() {
    var form = document.getElementById('CHOrderForm');
    var config = parseConfig('CHOrderFormConfig');
    if (!form || !config) return;

    var fileInput = document.getElementById('OrderFiles');
    var fileList = document.getElementById('OrderFileList');
    var statusEl = document.getElementById('OrderUploadStatus');
    var urlsField = document.getElementById('OrderArtworkUrls');
    var submitBtn = document.getElementById('OrderSubmitBtn');
    var maxBytes = (config.maxFileMb || 15) * 1024 * 1024;

    initFileList(fileInput, fileList);

    form.addEventListener('submit', function (e) {
      var first = document.getElementById('OrderFirstName');
      var last = document.getElementById('OrderLastName');
      var full = document.getElementById('OrderFullName');
      if (first && last && full) {
        full.value = (first.value + ' ' + last.value).trim();
      }

      var bodyEl = document.getElementById('OrderInstructions');
      if (bodyEl) {
        bodyEl.value = buildOrderSummary(form);
      }

      var files = fileInput && fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];
      if (!files.length) {
        return;
      }

      if (!config.uploadsEnabled || !config.cloudinaryCloud || !config.uploadPreset) {
        if (bodyEl) {
          bodyEl.value =
            buildOrderSummary(form) +
            '\n\nNote: Customer selected ' +
            files.length +
            ' file(s) but upload is unavailable — please request artwork by email.';
        }
        if (fileInput) fileInput.value = '';
        return;
      }

      for (var i = 0; i < files.length; i++) {
        if (files[i].size > maxBytes) {
          e.preventDefault();
          alert(
            files[i].name +
              ' is too large. Maximum ' +
              config.maxFileMb +
              'MB per file.'
          );
          return;
        }
      }

      e.preventDefault();
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'UPLOADING FILES…';
      }
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = 'Uploading artwork…';
      }

      var uploads = files.map(function (file, index) {
        if (statusEl) {
          statusEl.textContent =
            'Uploading ' + (index + 1) + ' of ' + files.length + '…';
        }
        return uploadToCloudinary(file, config.cloudinaryCloud, config.uploadPreset).then(
          function (data) {
            return data.secure_url || data.url;
          }
        );
      });

      Promise.all(uploads)
        .then(function (urls) {
          if (urlsField) urlsField.value = urls.join('\n');
          var bodyEl = document.getElementById('OrderInstructions');
          if (bodyEl) bodyEl.value = buildOrderSummary(form);
          if (statusEl) statusEl.textContent = 'Upload complete. Sending order…';
          form.submit();
        })
        .catch(function (err) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'SUBMIT ORDER REQUEST';
          }
          if (statusEl) {
            statusEl.textContent =
              'Upload failed. Try again or submit without files and email your artwork.';
          }
          console.error(err);
          alert(
            'Could not upload files. Check your connection and try again, or submit without files.'
          );
        });
    });
  }

  function initContactForm() {
    var form = document.getElementById('CHContactForm');
    var config = parseConfig('CHContactFormConfig');
    if (!form || !config) return;

    var fileInput = document.getElementById('ContactFiles');
    var fileList = document.getElementById('ContactFileList');
    var statusEl = document.getElementById('ContactUploadStatus');
    var urlsField = document.getElementById('ContactArtworkUrls');
    var submitBtn = document.getElementById('ContactSubmitBtn');
    var maxBytes = (config.maxFileMb || 15) * 1024 * 1024;

    initFileList(fileInput, fileList);

    form.addEventListener('submit', function (e) {
      var files = fileInput && fileInput.files ? Array.prototype.slice.call(fileInput.files) : [];
      if (!files.length) return;

      if (!config.uploadsEnabled || !config.cloudinaryCloud || !config.uploadPreset) {
        // Keep form usable: append a note and submit without blocking.
        var bodyField = form.querySelector('[name="contact[body]"]');
        if (bodyField && files.length) {
          var note =
            '\n\n[Customer selected ' +
            files.length +
            ' file(s) but uploads were unavailable. Please email artwork to sales@candhsigns.com.]';
          if (bodyField.value.indexOf('[Customer selected') === -1) {
            bodyField.value = (bodyField.value || '') + note;
          }
        }
        return;
      }

      for (var i = 0; i < files.length; i++) {
        if (files[i].size > maxBytes) {
          e.preventDefault();
          alert(files[i].name + ' is too large. Maximum ' + config.maxFileMb + 'MB per file.');
          return;
        }
      }

      e.preventDefault();
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'UPLOADING…';
      }
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = 'Uploading file…';
      }

      Promise.all(
        files.map(function (file) {
          return uploadToCloudinary(file, config.cloudinaryCloud, config.uploadPreset).then(
            function (data) {
              return data.secure_url || data.url;
            }
          );
        })
      )
        .then(function (urls) {
          if (urlsField) urlsField.value = urls.join('\n');
          var msg = form.querySelector('#ContactMessage');
          if (msg) {
            var extra = '\n\nAttached files:\n' + urls.join('\n');
            if (msg.value.indexOf('Attached files:') === -1) {
              msg.value = msg.value.trim() + extra;
            }
          }
          form.submit();
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'SUBMIT';
          }
          alert('Could not upload file. Try again or send your message without an attachment.');
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initOrderForm();
    initContactForm();
  });
})();
